import { fg } from '@atlaskit/platform-feature-flags/fg';

import { type EditionAwarenessContextType } from './edition-awareness-context';
import { isProductOneOf } from './is-product-one-of';

/**
 * Determines whether the current viewer should see the `ExploreEditionBenefitsModal`
 * because their tenant was auto-upgraded to a Standard trial due to a storage-limit
 * breach (entitlement `trialTrigger === 'AUTO_UPGRADE_STORAGE_LIMIT'`).
 *
 * This path is intentionally independent of:
 *  - the STAR experiment killswitch (`jsmgrowth-466_star_killswitch`)
 *  - the STAR experiment cohort (`jsmgrowth466_star`)
 *  - payment-details / invoiceable status
 *
 * Storage-triggered auto-upgrades are a separate user journey and need their own
 * gating + rollout control, so a dedicated killswitch governs only this path.
 */
export function isEligibleForExploreEditionBenefitsModalStorageLimit({
	product,
	edition,
	isInTrial,
	lastKnownTrial,
}: EditionAwarenessContextType): boolean {
	if (
		edition === 'standard' &&
		isInTrial &&
		isProductOneOf(product, ['jira-service-management', 'jira-customer-service']) &&
		lastKnownTrial?.trialTrigger === 'AUTO_UPGRADE_STORAGE_LIMIT' &&
		fg('post-trial-modal')
	) {
		return true;
	}

	return false;
}
